import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AudioProvider } from "./context/AudioContext";
import { AppDownloadProvider } from "./context/AppDownloadContext";
import GlobalPlayer from "./components/feature/GlobalPlayer";
import MobileAppShell from "./components/feature/MobileAppShell";
import AdminMobileGuard from "./components/feature/AdminMobileGuard";
import AppDownloadModal from "./components/feature/AppDownloadModal";
import { UpgradeModalProvider } from "./context/UpgradeModalContext";
import InternalUpgradeModal from "./components/feature/InternalUpgradeModal";
import GlobalLoadingScreen from "./components/feature/GlobalLoadingScreen";
import { useState, useEffect, useCallback } from "react";
import { CabinaProvider } from "./context/CabinaContext";
import { AuthProvider } from "./context/AuthContext";

function GlobalPlayerRouteGuard() {
  const location = useLocation();
  const isSARoute = location.pathname === "/sa" || location.pathname.startsWith("/sa/");
  if (isSARoute) return null;
  return <GlobalPlayer />;
}

function LoadingGuard() {
  const [showLoader, setShowLoader] = useState(true);
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAppReady(true);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  const handleLoaderComplete = useCallback(() => {
    setShowLoader(false);
  }, []);

  return (
    <>
      {showLoader && (
        <GlobalLoadingScreen
          visible={!appReady}
          minDuration={800}
          onComplete={handleLoaderComplete}
        />
      )}
      <AppRoutes />
      <GlobalPlayerRouteGuard />
      <AdminMobileGuard>
        <MobileAppShell />
      </AdminMobileGuard>
      <AppDownloadModal />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <AudioProvider>
          <AppDownloadProvider>
            <UpgradeModalProvider>
              <CabinaProvider>
                <BrowserRouter basename={__BASE_PATH__}>
                  <LoadingGuard />
                </BrowserRouter>
              </CabinaProvider>
              <InternalUpgradeModal />
            </UpgradeModalProvider>
          </AppDownloadProvider>
        </AudioProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;